module.exports = __webpack_public_path__ + "d96a902346d81ca40bd239baaa37601f.jpg";